<template>
    <div>
        <nsw-menu
                :isShowDesktopMenu="false"
        ></nsw-menu>
        <div class="content-wrapper general">
            <h3 class="title-head">{{ lang($t('Contact Us')) }}</h3>
            <h4 class="contact-title">{{ lang($t("Marketing Department, Hong Kong Educational Publishing Company Ltd.")) }}</h4>
            <div class="content-box contact">

                <p>顧客可於辦公時間透過以下方法聯絡本公司（市場部）。</p>

                <div class="divTable contact-info-table">
                    <div class="TBody">
                        <div class="TR">
                            <div class="TD"><img src="img/office-hour.svg"></div>
                            <div class="TD"><p>{{ lang($t("Monday to Friday 8:30a.m. - 5:30p.m.")) }}</p></div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/address.svg"></div>
                            <div class="TD"><p>{{ lang($t("9/F, Eastern Central Plaza, 3 Yiu Hing Road, Shaukeiwan, Hong Kong.")) }}</p></div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/phone.svg"></div>
                            <div class="TD"><p>2887 8018</p></div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/fax.svg"></div>
                            <div class="TD"><p>2570 9795</p></div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/email.svg"></div>
                            <div class="TD"><a class="txt-link" href="mailto:cs@hkep.com">cs@hkep.com</a></div>
                        </div>
                    </div>
                </div>

                <template v-if="file">
                    <a v-on:click="downloadFile()" target="_blank" href="javascript:void(0)" class="action-btn h32"><p>{{ lang($t("Download Form")) }}</p></a>
                </template>
<!--                <a target="_blank" href="http://www.hkep.com/promo/pripth/website_resources/LE20184091_04%20Add%20Sales.pdf" class="action-btn h32"><p>{{ lang($t("Download Form")) }}</p></a>-->

            </div>
            <template v-if="contact_list.length > 0">
                <h4 class="contact-title">{{ lang($t("Sales Information")) }}</h4>
                <div class="contact-staff-group">
                    <template v-for="item in contact_list">
                        <div class="staff-namecard">
                            <div class="name">
                                <p class="name-small">{{ item.name_en }}</p>
                                <p class="name-big">{{ item.name_zh }}</p>
                            </div>

                            <div class="divTable contact-info-table">
                                <div class="TBody">
                                    <div class="TR">
                                        <div class="TD"><img src="img/pin.svg"></div>
                                        <div class="TD"><p>{{ item.location }}</p></div>
                                    </div>
                                    <div class="TR">
                                        <div class="TD"><img src="img/phone.svg"></div>
                                        <div class="TD"><p>{{ item.mobile }}</p></div>
                                    </div>
                                    <div class="TR">
                                        <div class="TD"><img src="img/email.svg"></div>
                                        <div class="TD"><a class="txt-link" :href="'mailto:'+item.email">{{ item.email }}</a></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>

                </div>
            </template>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';
    import {nsw_common} from '@mixins/nsw_common';

    export default {
        name: "ContactUs",
        mixins:[common, storeMapper, nsw_common],
        data() {
            return {
                contact_list: [],
                file: ""
            }
        },
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm => {

                EventBus.$emit("showGlobalLoading");
                vm.setList();

                Promise.all(
                    [
                        api.getMainCate(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate(responseMainCate.data, vm);
                        }
                        EventBus.$emit("hideGlobalLoading");

                    }))
                /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */


            });
        },
        methods: {
            downloadFile() {
                let self = this;
                if (self.file) {

                    let full_path = nsw_common.getUriValue(self.file.uri);
                    nsw_common.openUrlByPath(full_path);



                }
            },
            setList()
            {
                let self = this;
                EventBus.$emit("showGlobalLoading");

                Promise.all(
                    [
                        api.getContactUsById(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((contactUsResp) => {

                        if (contactUsResp) {
                            self.contact_list = (contactUsResp.data.data)? contactUsResp.data.data:[];
                            self.file = contactUsResp.data.file;
                        }

                        EventBus.$emit("hideGlobalLoading");

                    }))
                /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */


            }
        }
    }
</script>

<style>
    .title-head:first-child {
        margin-top: 0;
    }

    .divTable {
        display: table;
        width: 100%;
    }

    .divTable .TBody {
        display: table-row-group;
    }

    .divTable .TR {
        display: table-row;
    }

    .divTable .TD {
        display: table-cell;
        vertical-align: top;
    }

    .content-box.contact{margin-bottom:1.5rem;}
    .content-box.contact>p{line-height:170%;padding-bottom:1.5rem;}
    h4.contact-title{font-size:1rem;padding-bottom:1rem;color:#608197;}
    .content-box.contact .action-btn{margin-top:1.5rem;}

    .contact-staff-group{display:grid;
        /* Display as a Grid */
        grid-template-columns:repeat(auto-fit, minmax(280px, 1fr));
        /* repeat = as many times as you can fit */
        /* auto-fit = fit as many items on the line as possible, go bigger if you need to */
        /*minmax = (min size, max size) = the minimum size the column should be is 200px, but if there's space then give them all 1fr of that width. */
        grid-gap:4px;}
    .staff-namecard{background-color:#fff;border:1px solid #d9e4eb;padding:1.5rem;
        -webkit-radius:6px;
        -moz-border-radiust:6px;
        border-radius:6px;}
    .contact-info-table .TD img{width:1.25rem;height:1.25rem;}
    .contact-info-table .TD{padding-bottom:.75rem;}
    .contact-info-table .TR:last-child .TD{padding-bottom:0rem;}
    .contact-info-table .TD:first-child{width:2.25rem;}
    .contact-info-table .TD:last-child{padding-top:.125rem;}
    .contact-info-table .TD p{color:#8d8d8d;}

    .staff-namecard .name{padding-bottom:1rem;}
    .staff-namecard .name-big{font-size:1.25rem;}
    .staff-namecard .name-small{font-size:1rem;padding-bottom:.125rem;}

    @media screen and (max-width:767px){
        h4.contact-title{padding:0 .5rem 1rem .5rem;}
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactUs.vue